import Calendar from "../../../../../../packages/design-system/src/Calendar";
import InfoBox from "../../../../../../packages/design-system/src/InfoBox";
import InformationCircleIcon from "../../../../../../packages/design-system/src/Icons/InformationCircleIcon";
import * as React from 'react';
export default {
  Calendar,
  InfoBox,
  InformationCircleIcon,
  React
};